import { Controller, useForm } from 'react-hook-form'

import postJSON from 'utils/postJSON'

import Button from 'components/Button'
import CheckboxInput from 'components/CheckboxInput'
import Header from 'components/Header'
import Label from 'components/Label'
import SelectInput from 'components/SelectInput'
import Spacer from 'components/Spacer'
import Text from 'components/Text'
import TextInput from 'components/TextInput'

import { NameInputs, Root, Submitted } from './ConsultationForm.style'

const locationOptions = [
  { value: 'New York', label: 'New York' },
  { value: 'Hong Kong', label: 'Hong Kong' },
]

const defaultValues = {
  firstName: '',
  lastName: '',
  emailAddress: '',
  location: null,
  message: '',
  subscribe: false,
}

const ConsultationForm = ({ artisan }) => {
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors, isSubmitting, isSubmitSuccessful },
  } = useForm({
    defaultValues: { ...defaultValues, artisan },
  })
  const onSubmit = async (data) => await postJSON(`${process.env.NEXT_PUBLIC_API_URI}/enquiry`, data)

  if (isSubmitSuccessful) {
    return (
      <Submitted>
        <Header size="sm">Thank you</Header>
        <Spacer y={2} />
        <Text>A member of The Armoury team will be with you shortly.</Text>
        <Spacer y={4} />
        <Button onClick={() => reset(defaultValues)} text="Submit another inquiry" variant="inline" />
      </Submitted>
    )
  }

  return (
    <Root onSubmit={handleSubmit(onSubmit)}>
      <NameInputs>
        <TextInput
          label="First Name"
          {...register('firstName', { required: 'Required', minLength: 2 })}
          error={errors.firstName}
        />
        <TextInput
          label="Last Name"
          {...register('lastName', { required: true, minLength: 2 })}
          error={errors.lastName}
        />
      </NameInputs>
      <TextInput
        label="Email Address"
        {...register('emailAddress', { required: true, pattern: /.+@.+/ })}
        error={errors.emailAddress}
      />
      <Label text="Location" error={errors.location}>
        <Controller
          name="location"
          rules={{ required: true }}
          control={control}
          render={({ field: { onChange, value, ref } }) => (
            <SelectInput
              ref={ref}
              label="Location"
              options={locationOptions}
              value={locationOptions.find((option) => option.value === value)}
              onChange={({ value }) => onChange(value)}
              error={errors.location}
            />
          )}
        />
      </Label>
      <TextInput
        label="How can we help?"
        multiline
        {...register('message', { required: true, minLength: 2 })}
        error={errors.message}
      />
      <CheckboxInput label="Subscribe to our newsletter" {...register('subscribe')} />
      <Button text={isSubmitting ? 'Submitting…' : 'Submit inquiry'} variant="outlined" disabled={isSubmitting} />
    </Root>
  )
}

ConsultationForm.propTypes = {}

ConsultationForm.defaultProps = {}

export default ConsultationForm
